import { saveAs } from "file-saver";

import Logger from "@/utility/logger";

interface DownloadableDocument {
  content_type: string;
  file_data: string;
  filename: string;
}

export function downloadAndOpenBase64File({ filename, content_type, file_data }: DownloadableDocument) {
  const byteCharacters = atob(file_data);
  const byteNumbers = new Array(byteCharacters.length);

  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: content_type });
  const reader = new FileReader();

  reader.onloadend = function () {
    const dataUrl = reader.result as string;

    if (
      typeof Office !== "undefined" &&
      Office.context &&
      Office.context.ui &&
      Office.context.ui.openBrowserWindow
    ) {
      saveAs(blob, filename);
      return;
    }

    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    if (content_type === "application/pdf") {
      const newTab = window.open();

      if (newTab) {
        newTab.document.write(
          `<body style="margin:0;"><iframe src="${dataUrl}" frameborder="0" style="width:100%;height:100%;border:none;"></iframe></body>`
        );
      }
    }

    Logger.debug(`documentDownload.ts: File "${filename}" downloaded successfully via data URL.`);
  };

  reader.readAsDataURL(blob);
}


